<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div mat-dialog-title>
  @if (!data.unit.id) {
    <span>Add</span>
    }@if (data.unit.id) {
    <span>Edit</span>
    } Unit
    <button
      mat-icon-button
      (click)="handleEditComplete(false)"
      title="Cancel"
      class="close-button"
      tabindex="-1"
      >
      <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
  </div>
  @if (!!data && data.unit !== undefined && data.unit !== null) {
    <div mat-dialog-content>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Name</mat-label>
            <input type="text" matInput [formControl]="unitNameFormControl" placeholder="Name (required)" (blur)="saveUnit('name')"
              value="{{data.unit.name}}">
            @if (unitNameFormControl.hasError('minlength') && !unitNameFormControl.hasError('required')) {
              <mat-error>
                Must contain {{ MIN_NAME_LENGTH }} or more characters
              </mat-error>
            }
            @if (unitNameFormControl.hasError('required')) {
              <mat-error>
                Name is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Short Name</mat-label>
            <input type="text" matInput [formControl]="unitShortNameFormControl" placeholder="Short Name (required)" (blur)="saveUnit('shortName')"
              value="{{data.unit.shortName}}">
            @if (unitShortNameFormControl.hasError('minlength') && !unitShortNameFormControl.hasError('required')) {
              <mat-error>
                Must contain {{ MIN_NAME_LENGTH }} or more characters
              </mat-error>
            }
            @if (unitShortNameFormControl.hasError('required')) {
              <mat-error>
                Short Name is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="cssLayoutRowStartCenter bottom-button">
        <div class="delete-button">
          <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree()" style="margin-left: 40px;">Save</button>
        </div>
        <div class="delete-button">
          <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
        </div>
      </div>
    </div>
  }
